export const APP_ROUTES = {
  home: "/",
  dashboard: "/dashboard",
  plan: "/plan",
  planPattern: "/plan/:dreamId",
  myDreams: "/dreams",
  dreamCreate: "/dreams/new",
  dreamDetailPattern: "/dreams/:id",
  goalDetailPattern: "/dreams/:id/goals/:goalId",
  settings: "/settings",
  profile: "/profile",
  planDream: (dreamId: string) => `/plan/${dreamId}`,
  dreamDetail: (dreamId: string) => `/dreams/${dreamId}`,
  goalDetail: (dreamId: string, goalId: string) => `/dreams/${dreamId}/goals/${goalId}`,
} as const;

